import React, {useEffect, useState} from "react";
import {useJournal} from "../../../providers/JournalContext";
import {useNavigate} from "react-router-dom";
import {Col, notification, Row} from "antd";
import "./form.scss";
import TableForumComp from "./TableForumComp";
import userImg from "./userImg1.jpeg";
import {CopyIcon} from "../../../../assets/icons/sidebarIcons";
import ThemeModals from "../../../components/common/modals/theme-modals/ThemeModals";
import CreateForum from "./CreateForum";
import {
  EditForum,
  GetForumNotes,
  GetForumResource,
  GetForumsService,
  GetForumUsers,
} from "../../../services/forum.service";
import {UserAuthService} from "../../../services/user-auth-api.service";
import {PenIconSession, RoundedCheck} from "../../../../assets/icons/defaultIcons";
import ForumSkeleton from "../../skeletons/forum/ForumSkeleton";
import NoRecord from "../../../components/dashboard/no-record/NoRecord";
import ForumLoaderSkeleton from "../../skeletons/forum/ForumLoaderSkeleton";
import ForumDetail from "./ForumDetail";
import {Form} from "react-bootstrap";
import {useForm} from "react-hook-form";
import BorderWrapper from "../../../components/dashboard/border-wrapper/BorderWrapper";
import ChangeForumName from "./ChangeForumName";
import {LuPlus} from "react-icons/lu";
import EditForumNote from "./EditForumNote";

const Forum = () => {
  const { firstTimeForumPassword } = useJournal();
  let navigate = useNavigate();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalDetailIsOpen, setModalDetailIsOpen] = useState(false);
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [forumNameModal, setForumNameModal] = useState(false);
  const [renderContent, setRenderContent] = useState(false);
  const [forumUsers, setForumUsers] = useState([]);
  const [resourceList, setResourceList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [profileDatas, setProfileDatas] = useState(false);
  const [selectedForum, setSelectedForum] = useState(null);
  const [loading, setLoading] = useState(true);
  const [forumLisitng, setFroumLisiting] = useState([]);
  const [authUser, setAuthUser] = useState('')
  const [listing, setListing] = useState(false)
  const [forumNote, setForumNote] = useState('')
  const [editForumNote, setEditForumNote] = useState(false)
  let AuthUser = UserAuthService.getAuthUser();
  const [loader , setLoader] = useState(false)


  console.log(authUser.forumId,'auth user')

  async function GetProfileData() {
    setLoading(true)
    const response = await UserAuthService.getProfileData();
    if (response?.data?.data?.status) {
      setLoading(false)
      setAuthUser(response.data?.data?.data?.user)
      if (!response.data?.data?.data?.user?.forumId){
        navigate('/')
      }
    }
  }


  useEffect(() => {
    GetProfileData();
  }, []);

  const HandleForum = async () => {
    let params = {
      paginate: false,
    };
    let res = await GetForumsService(authUser.forumId, params);
    setFroumLisiting(res?.data?.data?.data?.submissions);
    setIsLoading(false);
  };

  const HandleUserListing = async () => {
    let params = {
      paginate: false,
    };
    let res = await GetForumUsers(authUser.forumId, params);
    setForumUsers(res?.data?.data?.data?.members);
    setIsLoading(false);
  };

  const HandleResources = async () => {
    let res = await GetForumResource(authUser.forumId);
    setResourceList(res?.data?.data?.data);
    setIsLoading(false);
  };

  const GetForums = async () => {
    let res = await GetForumNotes();
    setForumNote(res?.data?.data?.data);
    console.log(res?.data?.data?.data, 'data forun')
  };

  useEffect(()=>{
    GetForums()
  },[])


  useEffect(() => {
    console.log("Listing changed, calling HandleResources...");
    if (authUser.forumId) {
      HandleResources();
    }

  }, [listing]);

  useEffect(() => {
    if (!authUser.forumId){
      return
    }
    setIsLoading(true);
    HandleForum();
    HandleUserListing();
    HandleResources();
  }, [renderContent, authUser, listing]);

  useEffect(() => {
    if (firstTimeForumPassword == false) {
      navigate("/forum/validate-password");
    }
  }, [firstTimeForumPassword]);

  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    control,
    clearErrors,
    watch,
  } = useForm({
    mode: "onChange",
  });

  const onSubmit = async (data) => {
    setLoader(true)
    let payload = {
      memberAssignedName: 'Hello'
    };
    try {
      let res = await EditForum(payload);
      if (res?.data?.data?.status) {
        notification.success({
          message: "Success",
          description: res?.data?.data?.message,
          placement: "topRight",
          icon: <RoundedCheck />,
          duration: 2,
        });
        reset();
        setLoader(false)
      }
    } catch (error) {

    } finally {
      setLoader(false)
    }
  };


  if (loading) {
    return (
        <ForumLoaderSkeleton/>
    );
  }


  if (isLoading) {
    return <ForumSkeleton />;
  }

  return (
    <>
      <div className={"main_div_forum"}>
        <Row gutter={[16, 16]}>
          <Col lg={12} xl={12} md={24} xs={24}>
            <div className={'mb-3'}>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="session_main_div">
                  <h5 className={'session-heading pt-0'}>Forum Notes: {forumNote?.note ?
                      <span className={'cp'} onClick={() => setEditForumNote(true)}><PenIconSession /></span>
                      :
                      <span className={'add-btn-text'} onClick={() => setEditForumNote(true)}><LuPlus /> Add Forum Note</span>}
                  </h5>
                  <div className={'section-para-box'}>
                    <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }} className={'section-para'}>
                      {
                        forumNote?.note && forumNote?.note
                      }
                    </p>
                  </div>

                </div>
              </Form>
            </div>
            <div className="col_1_forum">

              <div className="inner_div_col_1" style={{backgroundColor: '#232323', borderRadius: '15px', borderTop:'1px solid #FDFF9F'}}>
                <div className="header">
                  <h5>Progress Updates</h5>
                  <h4
                      className={"cp gratitude-head"}
                      onClick={() => setModalIsOpen(true)}
                  >
                    {" "}
                    + Submit 5% Update
                  </h4>
                </div>
                <div className="mt-5 table_list_height">
                  {forumLisitng &&
                  forumLisitng?.map((v, i) => {
                    return (
                        <TableForumComp
                            Data={v}
                            setModalIsOpen={setModalIsOpen}
                            setEditModalIsOpen={setEditModalIsOpen}
                            setDetailModalIsOpen={setModalDetailIsOpen}
                            setSelectedForum={setSelectedForum}
                            selectedForum={selectedForum}
                            setRenderContent={setRenderContent}
                            renderContent={renderContent}
                        />
                    );
                  })}
                  {
                    forumLisitng?.length === 0 &&
                    <NoRecord />
                  }
                </div>
              </div>
            </div>
          </Col>
          <Col lg={12} xl={12} md={24} xs={24}>
            <div className="forum_profile_section">
              <div className="inner_div_profile_forum">
                <h3>
                  {resourceList && resourceList?.name
                    ? resourceList?.name
                      : "-"}
                      {/*<span>(Main Forum)</span>*/}
                </h3>
                <div className={'forum-name-section'}>
                  {/*<p>Any user can change the forum name anytime.</p>*/}
                  <div className={'forum-name-change'}>
                    <span className={'forum-change-name'}>{resourceList && resourceList?.memberAssignedName
                        ? resourceList?.memberAssignedName
                        : "-"}</span>
                    <div style={{width:'100px'}}>
                      <BorderWrapper radius={8} margin={1} padding={1} width={'100px'}>
                      <span className={'btn forum-change-btn'} onClick={()=>{setForumNameModal(true)}}>
                        {resourceList && resourceList?.memberAssignedName
                            ? 'Change'
                            : "Add"
                        }
                      </span>
                      </BorderWrapper>
                    </div>

                  </div>
                </div>
                <h5 className={'mt-3'}>Users Profile</h5>
                <div className="inner_div_profile_map">
                  {forumUsers &&
                    forumUsers?.map((v, i) => {
                      return (
                        <div
                          className="user_profile"
                          onClick={() =>
                            navigate(`/forum/user-profile/${v?._id}`)
                          }
                        >
                          <div className="img_div">
                            <img
                              src={v?.profileImage ? v?.profileImage : userImg}
                            />
                          </div>
                          <p>{v?.fullName ? v?.fullName : "-"}</p>
                        </div>
                      );
                    })}
                  {
                    forumUsers?.length === 0 &&
                    <NoRecord/>
                  }
                </div>
              </div>
            </div>
            <div className="link_section">
              <div className="inner_div_link">
                <div className="link_header">
                  <h3>Resources Links</h3>
                </div>
                <div className="links_resource">
                  {resourceList &&
                  resourceList?.resourceLinks?.map((v, i) => {
                    const copyToClipboard = (url) => {
                      navigator.clipboard
                          .writeText(url)
                          .then(() => {
                            notification.success({
                              message: "Success",
                              description: "URL copied to clipboard!",
                              placement: "bottomRight",
                              icon: <RoundedCheck />,
                              duration: 2,
                            });
                          })
                          .catch((err) => {
                            console.error("Failed to copy: ", err);
                          });
                    };


                    return (
                        <div className="links_resource_inner" key={i}>
                          <div className="link_title">
                            {/*<p>{v?.name}</p>*/}
                            <p className="para">
                              <a href={v?.url} target="_blank" rel="noopener noreferrer">
                                {v?.name}
                              </a>
                            </p>
                          </div>
                          <div className="Icon_link" onClick={() => copyToClipboard(v?.url)}>
                            <CopyIcon />
                          </div>
                        </div>
                    );
                  })}
                  {
                    resourceList?.resourceLinks?.length === 0 &&
                    <NoRecord/>
                  }
                  {/*{*/}
                  {/*  resourceList?.length < 0 &&*/}
                  {/*  <div*/}
                  {/*      style={{*/}
                  {/*        display: "flex",*/}
                  {/*        flexDirection: "row",*/}
                  {/*        alignItems: "center",*/}
                  {/*        justifyContent: "center",*/}
                  {/*      }}*/}
                  {/*  >*/}
                  {/*    <p*/}
                  {/*        style={{*/}
                  {/*          color: "white",*/}
                  {/*          fontSize: "16px",*/}
                  {/*          fontWeight: "bold",*/}
                  {/*        }}*/}
                  {/*    >*/}
                  {/*      No Resource Link Found*/}
                  {/*    </p>*/}
                  {/*  </div>*/}
                  {/*}*/}

                  {/*<div className="main_div_link_empty">
                    <div className="link_empty">Empty link 2</div>
                  </div>
                  <div className="main_div_link_empty">
                    <div className="link_empty">Empty link 3</div>
                  </div>*/}
                </div>
              </div>
            </div>
            <div className={'forum-qiestions'}>
              <h3>For All Forum Related Questions</h3>
              <p><span>Contact Email:</span> <a href="mailto:Bryan@riseupkings.com">Bryan@riseupkings.com</a></p>
              <p><span>Contact:</span> <a href="tel:5415141663">541-514-1663</a></p>
            </div>
          </Col>
        </Row>
      </div>
      <ThemeModals
          open={modalDetailIsOpen}
        close={setModalDetailIsOpen}
        title={"5% Update Submission"}
        // className={"forum_modal"}
        width={1000}
        content={
          <ForumDetail
            close={setModalDetailIsOpen}
            setRenderContent={setRenderContent}
            renderContent={renderContent}
            selectedForum={selectedForum}
            isEdit={false}
          />
        }
      />
      <ThemeModals
          open={modalIsOpen}
          close={setModalIsOpen}
          title={"5% Update Submission"}
          // className={"forum_modal"}
          width={1000}
          content={
            <CreateForum
                setModalIsOpen={setModalIsOpen}
                setRenderContent={setRenderContent}
                renderContent={renderContent}
                selectedForum={null}
                isEdit={false}
            />
          }
      />
      <ThemeModals
          open={editForumNote} close={setEditForumNote}
          title={'Forum Note'}
          // className={"forum_modal"}
          content={
            <EditForumNote open={editForumNote} close={setEditForumNote} clientData={forumNote} setClientData={setForumNote}/>
          }
      />
      <ThemeModals
        open={editModalIsOpen}
        close={setEditModalIsOpen}
        title={"5% Update Submission"}
        // className={"forum_modal"}
        width={1000}
        content={
          <CreateForum
            setModalIsOpen={setEditModalIsOpen}
            setRenderContent={setRenderContent}
            renderContent={renderContent}
            selectedForum={selectedForum}
            isEdit={true}
          />
        }
      />
      <ThemeModals
          open={forumNameModal}
          close={setForumNameModal}
          title={"Forum Name"}
          // className={"forum_modal"}
          content={
            <ChangeForumName
                close={setForumNameModal}
                ForumName={resourceList && resourceList?.memberAssignedName}
                listing={listing}
                setListing={setListing}
            />
          }
      />
    </>
  );
};

export default Forum;
